"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: 'loginBlackList:view',
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    // Pagination,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['loginBlackListRoleOptions'])),
  data: function data() {
    return {
      dialogVisible: false,
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: false,
      role: null,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        agentName: "",
        organizationUserName: ""
      },
      downloadLoading: false,
      multipleSelection: []
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      if (this.role == 'agent') {
        this.getAgentBlackList();
      }

      if (this.role == 'organizationUser') {
        this.getOrganizationUserBlackList();
      }
    },
    getAgentBlackList: function getAgentBlackList() {
      var _this = this;

      var params = this.getQueryParams();
      this.listLoading = true;

      _httpUtils.default.post("agent", "getBlackList", null, params).then(function (res) {
        //let index;
        _this.list = res.data.rows; // this.total = res.data.total;
      });

      setTimeout(function () {
        _this.listLoading = false;
      }, 1 * 1000);
    },
    getOrganizationUserBlackList: function getOrganizationUserBlackList() {
      var _this2 = this;

      var params = this.getQueryParams();
      this.listLoading = true;

      _httpUtils.default.post("organizationUser", "getBlackList", null, params).then(function (res) {
        //let index;
        _this2.list = res.data.rows; // this.total = res.data.total;
      });

      setTimeout(function () {
        _this2.listLoading = false;
      }, 1 * 1000);
    },
    getQueryParams: function getQueryParams() {
      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        number: this.queryParameter.phoneNumber
      };
    },
    handleFilter: function handleFilter() {
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm(_lang.default.t('warningMessage.deleteBlackListConfirmMessage'), _lang.default.t('warningMessage.deleteBlackListMessage'), {
        confirmButtonText: _lang.default.t('common.confirm'),
        cancelButtonText: _lang.default.t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this3.listLoading = true;

        if (_this3.role == 'agent') {
          _httpUtils.default.post("agent", "deleteBlackList", null, id).then(function (res) {
            _this3.$message({
              message: _lang.default.t('warningMessage.deleteBlackListSuccessMessage'),
              type: 'success'
            });

            _this3.handleFilter();
          });
        }

        if (_this3.role == 'organizationUser') {
          _httpUtils.default.post("organizationUser", "deleteBlackList", null, id).then(function (res) {
            _this3.$message({
              message: _lang.default.t('warningMessage.deleteBlackListSuccessMessage'),
              type: 'success'
            });

            _this3.handleFilter();
          });
        }
      }).catch(function (error) {
        _this3.$message({
          message: error.message,
          type: 'error'
        });
      });
      setTimeout(function () {
        _this3.listLoading = false;
      }, 1 * 1000);
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this4 = this;

      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t('message.selectBlackListToDeleteMessage'),
          type: 'error'
        });
      } else {
        this.$confirm(_lang.default.t('warningMessage.deleteBlackListConfirmMessage'), _lang.default.t('warningMessage.deleteBlackListMessage'), {
          confirmButtonText: _lang.default.t('common.confirm'),
          cancelButtonText: _lang.default.t('common.cancel'),
          type: 'warning'
        }).then(function () {
          _this4.listLoading = true;
          var ids = [];

          for (var item in _this4.multipleSelection) {
            ids.push(_this4.multipleSelection[item].id);
          }

          if (_this4.role == 'agent') {
            _httpUtils.default.post("agent", "batchDeleteBlackList", null, ids).then(function (res) {
              _this4.$message({
                message: _lang.default.t('warningMessage.deleteBlackListSuccessMessage'),
                type: 'success'
              });

              _this4.handleFilter();
            });
          }

          if (_this4.role == 'organizationUser') {
            _httpUtils.default.post("organizationUser", "batchDeleteBlackList", null, ids).then(function (res) {
              _this4.$message({
                message: _lang.default.t('warningMessage.deleteBlackListSuccessMessage'),
                type: 'success'
              });

              _this4.handleFilter();
            });
          }
        }).catch(function (error) {
          _this4.$message({
            message: error.message,
            type: 'error'
          });
        });
        setTimeout(function () {
          _this4.listLoading = false;
        }, 1 * 1000);
      }
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;